module.exports = __webpack_public_path__ + "static/media/zaha park shot 2-mobile.58e70403.webp";